/* eslint react/no-direct-mutation-state: "off",'array-callback-return': 'off', eqeqeq: 'off' */
import React, { Component } from 'react';
import { Col, Button, FormGroup, Label, Input } from 'reactstrap';
import { connect } from "react-redux";
import 'react-table/react-table.css';
import { GetDatalogMeterObjects, GetUnitsList } from '../../../../../../../action/createtenantAction';
import DMResources from '../../../../../../../Resources/DMResources.en-US';
import Currencies from '../../../../../../../Resources/Currencies';
import ErrorGif from '../../../../../../../Assets/images/Error.gif';
import SearchableEquipmentDropDown from './MeterSearchableDropdown';
import ReactDOM from 'react-dom';  
import { Icon } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import LoadProgressIndicator from '../../../../../../../Assets/images/ProgressIndicator.gif';

let CurrencySymb = "";
let Unit_Custom_Text = <option id='99999'>{'Custom'}</option>;
let Meter_data = null, Meter_List_length = 0, Units_in_Select_input1 = null;

class AddMetersSearch extends Component {
    async componentWillMount(){
        const meters = this.props.GetDatalogMeterObjects();
        await Promise.all([meters]);
        this.setState({IsMetersLoading: false});
        if (this.props.MeterListIndex != null) {
            let list = this.props.MeterListIndex;
            let lent = list.length;
            if (list[lent - 1] != undefined) {
                Meter_List_length = list[lent - 1].id + 1;
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('wheel', this.handleMouseScroll);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('wheel', this.handleMouseScroll);
        var IsEdit = this.props.IsEdit;
        if (IsEdit != null && IsEdit) {
            if (this.props.MeterListDetail != null) {
                Meter_data = this.props.MeterListDetail;
                if (Meter_data.unit != 99999) {
                    this.LoadUnitsBasedOnDimension(Meter_data.dimension, Meter_data.unit, true);
                } else {
                    Units_in_Select_input1 = Unit_Custom_Text;
                }

                let IsTabbed = this.props.IsTabbedView;
                let UnitValue = '';

                if (IsTabbed != null && IsTabbed) {
                    UnitValue = Meter_data.unit != 99999 ? DMResources.FamilyList('Enum3047.' + Meter_data.unit + '.Text') : 'Custom';
                }
                else {
                    UnitValue = Meter_data.unitName;
                }
                let UnitSymb = Meter_data.unit != 0 && Meter_data.unit != 99999 ? DMResources.FamilyList('Enum3046.' + Meter_data.unit + '.Text') : Meter_data.unitText;
                let Symb = CurrencySymb + ' per ' + UnitSymb;
                let IsCustom = Meter_data.unit != 99999 && Meter_data.unit != 98 ? true : false;
                let CustomText = Meter_data.unit === 98 ? DMResources.FamilyList('Enum3047.' + Meter_data.unit + '.Text') : Meter_data.unitText;

                let Object_Id = Meter_data.objectId;
                let Object_Name = Meter_data.objectName;
                let Site_Id = Meter_data.buildingId;
                let Site_Name = Meter_data.buildingName;
                this.setState({
                    UnitsStatus: false,
                    inputValue: Meter_data.customName,
                    RateinputValue: Meter_data.rate,
                    MultiplierinputValue: Meter_data.multiplier,
                    UnitValue: UnitValue,
                    error_msg: false,
                    CustomUnitText: CustomText,
                    CurrencyUnitText: Symb,
                    UnitText: IsCustom,
                    EquipmentId: Object_Id,
                    EquipmentName: Object_Name,
                    SiteId:Site_Id,
                    SiteName:Site_Name,
                });
            }
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            error_msg: false,
            inputValue: '',
            MultiplierinputValue: '',
            RateinputValue: '',
            UnitValue: '',
            UnitsStatus: true,
            CustomUnitText: '',
            CurrencyUnitText: '',
            UnitText: false,
            Units_in_Select_input: "",
            CustomError: 'none',
            EquipmentId: 0,
            EquipmentName: '',
            EquipmentData:[],
            EquipmentDropDownStyles: {
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex:"9999",
                width:"554px", 
                maxHeight:"300px", 
                overflowY: "auto", 
                border: "1px solid black",
                backgroundColor:"white",
                opacity: 0,
                display: "none",
                pointerEvents: "none"
              },
            DimensionId : 0,
            DefaultUnitId : 0,
            SiteId : 0,
            SiteName : '',
            IsMetersLoading: true
        };
        this.ComputeEquipmentStyle = this.ComputeEquipmentStyle.bind(this);
        this.setEquipmentWrapperRef =this.setEquipmentWrapperRef.bind(this);
        this.setEquipment = this.setEquipment.bind(this);
        this.LoadUnits = this.LoadUnits.bind(this);
        this.LoadUnitSymbol = this.LoadUnitSymbol.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleMouseScroll = this.handleMouseScroll.bind(this);
    }

    handleClickOutside(event) {
        if (this.equipWrapperRef && !this.equipWrapperRef.contains(event.target)) {
            let StateChange = {...this.state.EquipmentDropDownStyles};
           StateChange.opacity = 0;
           StateChange.pointerEvents = "none";
            this.setState({EquipmentDropDownStyles:StateChange});
        }
    }

    handleMouseScroll(event){
        if (this.equipWrapperRef && !this.equipWrapperRef.contains(event.target)) {
            let StateChange = {...this.state.EquipmentDropDownStyles};
            StateChange.opacity = 0;
            StateChange.pointerEvents = "none";
            this.setState({EquipmentDropDownStyles:StateChange}); 
        }
    }

    ComputeEquipmentStyle(){
        var offset = ReactDOM.findDOMNode(this.refs.equipments_in_Select_input).getBoundingClientRect();
        let StateChange = {...this.state.EquipmentDropDownStyles};
        StateChange.opacity = 1;
        StateChange.display = "block";
        StateChange.pointerEvents = "auto";
        StateChange.top = parseInt(offset.top) + parseInt(offset.height) + 1;
        StateChange.left= parseInt(offset.left);
        this.setState({EquipmentDropDownStyles:StateChange});
    }

    setEquipmentWrapperRef(node){
        this.equipWrapperRef = node;
    }

    setEquipment(id,name,dimensionId,defaultUnitId,siteId,siteName){
        let StateChange = {...this.state.EquipmentDropDownStyles};
        StateChange.opacity = 0;
        StateChange.pointerEvents = "none";
        this.setState({
            EquipmentId:id,
            EquipmentName:name,
            DimensionId:dimensionId,
            DefaultUnitId:defaultUnitId,
            SiteId:siteId,
            SiteName:siteName,
            EquipmentDropDownStyles:StateChange
        }); 
        this.LoadUnits(dimensionId,defaultUnitId);
    }

    LoadUnits(DimensionIDs,UserDefinedUnits) {
        this.setState({ CustomUnitText: '', CurrencyUnitText: CurrencySymb + ' per ', UnitText: true });
        this.LoadUnitsBasedOnDimension(DimensionIDs, UserDefinedUnits, false);
    }

    LoadUnitsBasedOnDimension(a_Dimension, a_UserDefinedUnits, IsEdit) {
        this.setState({ UnitsStatus: false });
        Units_in_Select_input1 = "";
        let UnitText = "Unit";
        Unit_Custom_Text = <option id='99999'>{'Custom'}</option>;

        const actionResponse = this.props.GetUnitsList(a_Dimension, a_UserDefinedUnits);
        actionResponse.then((result) => {
            if (this.props.Units_List_Response != undefined && this.props.Units_List_Response.BuildingUnitsDetailsList != undefined && this.props.Units_List_Response.BuildingUnitsDetailsList != null) {
                let lent = this.props.Units_List_Response.BuildingUnitsDetailsList.length;
                if (a_Dimension > 0) {
                    if (lent > 1) {
                        Units_in_Select_input1 = this.props.Units_List_Response.BuildingUnitsDetailsList.map(el => {
                            if(DMResources.FamilyList('Enum3047.' + el + '.Text') != undefined)
                            return <option id={el} key={el}>{DMResources.FamilyList('Enum3047.' + el + '.Text')}</option>
                        });

                        let unitname = (this.props.userPrefs != undefined && this.props.userPrefs.UserPreference != undefined && this.props.userPrefs.UserPreference.units != undefined && this.props.userPrefs.UserPreference.units.filter(x => x.dimension == a_Dimension).length > 0 && IsEdit == false) ? this.props.userPrefs.UserPreference.units.filter(x => x.dimension == a_Dimension)[0].unitName : this.state.UnitValue;
                        let unitsymbol = (this.props.userPrefs != undefined && this.props.userPrefs.UserPreference != undefined && this.props.userPrefs.UserPreference.units != undefined && this.props.userPrefs.UserPreference.units.filter(x => x.dimension == a_Dimension).length > 0 && IsEdit == false) ? this.props.userPrefs.UserPreference.units.filter(x => x.dimension == a_Dimension)[0].unit : this.props.Units_List_Response.BuildingUnitsDetailsList[0];
                        let Currency = ( IsEdit == false) ? CurrencySymb + ' per ' + DMResources.FamilyList('Enum3046.' + unitsymbol + '.Text') : this.state.CurrencyUnitText;
                        this.setState({ CurrencyUnitText: Currency,
                            UnitValue: unitname });
                    }
                    else {
                        this.setState({ UnitsStatus: true, UnitText: false });
                        if (lent > 0) {
                            let lCurrencyUnitText = CurrencySymb + ' per ' + DMResources.FamilyList('Enum3046.' + this.props.Units_List_Response.BuildingUnitsDetailsList[0] + '.Text');
                            let lCustomUnitText = DMResources.FamilyList('Enum3047.' + this.props.Units_List_Response.BuildingUnitsDetailsList[0] + '.Text');
                            this.setState({ CurrencyUnitText: lCurrencyUnitText, CustomUnitText: lCustomUnitText });

                            Units_in_Select_input1 = this.props.Units_List_Response.BuildingUnitsDetailsList.map(el => (
                                <option id={el} key={el}>{'Custom'}</option>
                            ));
                            Unit_Custom_Text = "";
                        } else {
                            Units_in_Select_input1 = Unit_Custom_Text;
                            let lCurrencyUnitText = CurrencySymb + ' per ' + UnitText;
                            this.setState({ CurrencyUnitText: lCurrencyUnitText, CustomUnitText: UnitText });
                            Unit_Custom_Text = "";
                        }
                    }
                } else {
                    let l_ShowUnitTxtField = true;
                    this.setState({ UnitsStatus: true });
                    if (a_UserDefinedUnits > 0 && DMResources.FamilyList('Enum3047.' + a_UserDefinedUnits + '.Text') !== undefined) {
                        if (lent > 0) {
                            this.setState({ UnitsStatus: false });
                            l_ShowUnitTxtField = false;

                            if (lent === 1 && DMResources.FamilyList('Enum3046.' + a_UserDefinedUnits + '.Text') !== undefined) {
                                let lCurrencyUnitText = CurrencySymb + ' per ' + DMResources.FamilyList('Enum3046.' + a_UserDefinedUnits + '.Text');
                                this.setState({ CurrencyUnitText: lCurrencyUnitText });
                            }
                            if (DMResources.FamilyList('Enum3046.' + a_UserDefinedUnits + '.Text') !== undefined) {
                                Units_in_Select_input1 = this.props.Units_List_Response.BuildingUnitsDetailsList.map(el => (
                                    <option id={el} key={el}>{DMResources.FamilyList('Enum3047.' + el + '.Text')}</option>
                                ));
                            }else{
                                l_ShowUnitTxtField = true;
                            }
                        } else {
                            Units_in_Select_input1 = <option id={a_UserDefinedUnits} key={a_UserDefinedUnits}>{'Custom'}</option>;
                            Unit_Custom_Text = "";
                            let lCustomUnitText = DMResources.FamilyList('Enum3047.' + a_UserDefinedUnits + '.Text');
                            let lCurrencyUnitText = CurrencySymb + ' per ' + DMResources.FamilyList('Enum3047.' + a_UserDefinedUnits + '.Text');
                            this.setState({ CurrencyUnitText: lCurrencyUnitText, CustomUnitText: lCustomUnitText });
                            l_ShowUnitTxtField = IsEdit ? false : true;
                        }
                    } else {
                        Units_in_Select_input1 = Unit_Custom_Text;
                    }
                    if (l_ShowUnitTxtField) this.setState({ UnitText: false }); else this.setState({ UnitText: true });
                }
                this.setState({ Units_in_Select_input: Units_in_Select_input1 });
            }
        })
    }

    LoadUnitSymbol() {

        var selectedoption = this.refs.Units_in_Select_input.options.selectedIndex;
        let UnitId = this.refs.Units_in_Select_input.options[selectedoption].id;
        const UnitName = this.refs.Units_in_Select_input.options[selectedoption].value;
        this.setState({ UnitValue: UnitName });

        if (UnitId == '99999') {
            this.setState({ UnitText: false, CustomUnitText: '', CurrencyUnitText: CurrencySymb + ' per ' });
        }
        else {
            let Symb = CurrencySymb + ' per ' + DMResources.FamilyList('Enum3046.' + UnitId + '.Text');
            this.setState({ CurrencyUnitText: Symb, UnitText: true });
        }
    }

    updateMeterNameValue(evt) {
        this.setState({
            inputValue: evt.target.value
        });
    }

    updateCustomInputValue(evt) {
        var unittext = evt.target.value;
        let Symb = CurrencySymb + ' per ' + unittext;
        this.setState({
            CustomUnitText: unittext,
            CurrencyUnitText: Symb
        });
    }

    updateMultiplierInputValue(evt) {
        this.setState({
            MultiplierinputValue: evt.target.value
        });
    }

    updateRateInputValue(evt) {
        this.setState({
            RateinputValue: evt.target.value
        });
    }

    OnSaveMeter() {
        this.setState({ error_msg: false, CustomError: 'none'});
        var IsValid = true;
        var IsEdit = this.props.IsEdit;
        let IsTabbed = this.props.IsTabbedView;
        let id = 0;
        if (IsEdit == null || !IsEdit) {
            Meter_data = null;
            id = Meter_List_length;
        }
        else if (IsTabbed == null || !IsTabbed) {
            id = Meter_data.id;
        }

        let Meter_Name = this.state.inputValue;

        let Units_Select = this.refs.Units_in_Select_input.options.selectedIndex;
        let Unit_Name = this.refs.Units_in_Select_input.options[Units_Select].value;
        let Unit_Id = this.refs.Units_in_Select_input.options[Units_Select].id;

        let Custom_Units_Name = this.state.CustomUnitText;

        let Rate_Select = this.state.RateinputValue;
        let Multiplier_Select = this.state.MultiplierinputValue;
        if (Number.isNaN(Number(Rate_Select))) {
            IsValid = false;
        }
        if(Number.isNaN(Number(Multiplier_Select))){
            IsValid = false;
        }

        let Rate = (Rate_Select == null || Rate_Select == "") ? 0 : parseFloat(Rate_Select).toFixed(2);
        let Multiplier = (Multiplier_Select == null || Multiplier_Select == "") ? 0 : parseFloat(Multiplier_Select).toFixed(2);
        let Custom_Unit_Text = (Unit_Id == "99999") ? Custom_Units_Name : Unit_Name;
        let Unit = (Unit_Id == "" || Unit_Id == null) ? 0 : Number(Unit_Id);
        let MeterName = (Meter_Name == null) ? "" : Meter_Name;

        if (Meter_Name === "" || this.state.EquipmentId === 0 || this.state.EquipmentName === '') {
            IsValid = false;
        }
        if (Unit_Id == "99999" && Custom_Units_Name == "") {
            IsValid = false;
            this.setState({ CustomError: 'block' });
        }
        

        if (IsValid) {
            var MeterList = {
                "objectId": this.state.EquipmentId,
                "objectName": this.state.EquipmentName,
                "rate": Rate,
                "multiplier": Multiplier,
                "dimension": this.state.DimensionId,
                "unitText": Custom_Unit_Text,
                "unit": Unit,
                "buildingId": this.state.SiteId,
                "buildingName": this.state.SiteName,
                "customName": MeterName,
                "id": id,
                "unitName": Unit_Name
            }

            Meter_data = MeterList;
            this.props.CloseModal(Meter_data);
        } else {
            this.setState({ error_msg: true });
        }
    }

    render(manageTenantsParams, CurrencyID, DatalogMeterObjects_List_Response){
        let modal_form_1 = null;
        let Error_Message, Datalog_Error_Message, IsDatalogExistsForEditObject = false;
        var CloseModal = this.props.CloseModal;
        let DatalogObjects = this.props.DatalogMeterObjects_List_Response.BuildingDatalogObjectDetailsList;
        
        if (this.props.manageTenantsParams != undefined && !this.props.IsTabbedView) {
            CurrencySymb = Currencies.CurrencySymbol(this.props.manageTenantsParams.CurrencyId);
        } else {
            if (this.props.CurrencyID != undefined && this.props.CurrencyID != null) {
                CurrencySymb = Currencies.CurrencySymbol(this.props.CurrencyID);
            }
        }

        let Header_Text = (!this.props.IsEdit) ? "Add Meter" : "Edit Meter";
        (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  Error: You left necessary fields blank or entered invalid values.</p> : Error_Message = " ";

        if (DatalogObjects != undefined && DatalogObjects !== null && DatalogObjects.length) {
            var l_Equipmentdata = [], Equiplineitem = ''; 
            DatalogObjects.forEach(element => {
                if(this.state.EquipmentId === element.objectID){
                    IsDatalogExistsForEditObject = true;
                }
                Equiplineitem = {
                    "EquipmentId": element.objectID,
                    "EquipmentName": element.objectName,
                    "SiteId":element.siteID,
                    "SiteName": element.siteName, 
                    "PanelName": element.panelName, 
                    "DimensionId": element.dimensionId,
                    "DefaultUnitId": element.defaultUnitId
                }
                l_Equipmentdata.push(Equiplineitem);
            });
            this.state.EquipmentData = l_Equipmentdata;
        }

        if(!IsDatalogExistsForEditObject && this.props.IsEdit && this.props.IsTabbedView) {
            Datalog_Error_Message = <p className="error_msg"> <Icon name='exclamation triangle' style={{'color':'red', 'padding-left': '8px', 'padding-right': '14px'}} />DataLog no longer exist for the point configured</p> 
            this.state.EquipmentId = 0;
            this.state.EquipmentName = '';
        }
        else{ 
            Datalog_Error_Message = " ";
        }

        modal_form_1 = <div>
            {Error_Message}
            {Datalog_Error_Message}
            <h4 className="form_title">{Header_Text}</h4>
            <div className="form_group_modal" style={{padding:"1px"}}>
                <Label className="Custom_label"><b>Name</b></Label>
                <input id="createtenant_meter_name" type="text" className="InputFieldStyle default-input" style={{ width: '400px' }} value={this.state.inputValue} onChange={evt => this.updateMeterNameValue(evt)} />
            </div>
            <legend className="form_sub_title">Data Source</legend>
            <div className="form_group_modal" style={{padding:"1px"}} >
                <Label className="Custom_label"><b>Equipment</b></Label>
                <input type="text" id="createtenant_meter_equip" ref='equipments_in_Select_input' value={this.state.EquipmentName} disabled={this.state.IsMetersLoading ? true : false} className="InputFieldStyle default-input MeterDatalog" style={{width:'56%', height:'15'}} placeholder="Choose One" onClick={this.ComputeEquipmentStyle} />
                <img src={LoadProgressIndicator} alt="loadingprogress" style={{"padding-left":"10px","display":this.state.IsMetersLoading?"initial":"none"}} />
            </div>
            <div className="form_group_modal" style={{padding:"1px"}}>
                <Label className="Custom_label"><b>Units</b></Label>
                <select id="createtenant_meter_units" className="InputFieldStyle" ref='Units_in_Select_input'  style={{ width: '150px' }}  value={this.state.UnitValue} disabled={this.state.UnitsStatus} onChange={this.LoadUnitSymbol}>
                    {this.state.Units_in_Select_input}
                    {Unit_Custom_Text}
                </select> &emsp;
                <span style={{ color: 'red', float: 'right', 'padding-right': '130px', display: this.state.CustomError }}>!</span>
                <input id="createtenant_meter_unittext" type="text" style={{float :'none', width: '150px' }} className="InputFieldStyle default-input MeterDatalog" disabled={this.state.IsMetersLoading ? true : false} hidden={this.state.UnitText} value={this.state.CustomUnitText} onChange={evt => this.updateCustomInputValue(evt)} ref='Units_Text_input' />

            </div>
            <div className="form_group_modal" style={{padding:"1px"}}>
                <Label className="Custom_label"> <b>Rate</b></Label>
                <input type="text" id="createtenant_meter_rate" className="InputFieldStyle default-input MeterDatalog" disabled={this.state.IsMetersLoading ? true : false} style={{ width: '150px' }}  value={this.state.RateinputValue} onChange={evt => this.updateRateInputValue(evt)}/>&emsp;
                <Label style={{ width: '150px',"font-family":"Arial" }}>{this.state.CurrencyUnitText}</Label>
            </div>

            <div className="form_group_modal" style={{padding:"1px"}}>
                <Label className="Custom_label"><b>Multiplier</b></Label>
                <Input id="createtenant_meter_multiplier" className="InputFieldStyle default-input MeterDatalog" type="text" disabled={this.state.IsMetersLoading ? true : false} style={{ width: '150px' }} value={this.state.MultiplierinputValue} onChange={evt => this.updateMultiplierInputValue(evt)} />
            </div>
            
             <FormGroup row className="btns_group">
                <Col sm={{ size: 10 }}>
                    <Button id="createtenant_meter_cancel" className="btn-gray btn-md" onClick={() => CloseModal('Cancel')} > Cancel </Button>
                    <Button id="createtenant_meter_save" className="btn-success btn-md MeterDatalog" disabled={this.state.IsMetersLoading ? true : false} onClick={() => { this.OnSaveMeter() }}> Save </Button>
                </Col>
            </FormGroup>
        </div>
        
        return (
            <div>
                {modal_form_1}
                <SearchableEquipmentDropDown name="Equipmentdropdown" refMethod={this.setEquipmentWrapperRef} groupname="rdEquipment" selectedEquipment={this.state.EquipmentId} data={this.state.EquipmentData} elementStyle={this.state.EquipmentDropDownStyles} setValue={this.setEquipment} />
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        manageTenantsParams: state.manageTenant.ClientSideComapnyData,
        CurrencyID: state.ViewtenantsRootReducer.CompanyInformation.currencyId,
        userPrefs: state.userPreferencesRootReducer,
        DatalogMeterObjects_List_Response: state.BuildingDatalogObjectsReducer,
        Units_List_Response: state.BuildingUnitsReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetDatalogMeterObjects: () => dispatch(GetDatalogMeterObjects()),
        GetUnitsList: (dimensionID, UserDefinedID) => dispatch(GetUnitsList(dimensionID, UserDefinedID))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddMetersSearch);